import React, { FormEvent } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  CheckboxGroup,
  CheckboxPanel,
  Grid,
  Heading,
  Panel,
} from '@printdeal/ui-library';
import { getCategoryName } from '@printdeal/business-logic';
import QuoteLineItem from './QuoteLineItem';
import { QuoteLineItem as QuoteLineItemType } from '../../../../../types/quotes/quoteLineItems';
// @ts-expect-error
import { getLocalized } from '../../../../../helpers/getLocalisedData';
import { Money } from '../../../../Money';

interface Props {
  lineItems: QuoteLineItemType[];
  setSelectedLineItems: (lineItemIds: string[]) => void;
  selectedLineItems: string[];
}

const QuoteLineItemList = ({
  lineItems,
  setSelectedLineItems,
  selectedLineItems,
}: Props) => {
  const { locale } = useIntl();
  const getProductDetails = (lineItem: QuoteLineItemType) => {
    const { merchandisingProductName, quantity, price } = lineItem;
    const localizedProductName = getLocalized(locale, merchandisingProductName);
    const productName = getCategoryName(lineItem, locale) || localizedProductName;
    return {
      productName,
      quantity,
      price,
    };
  };
  const handleValueChange = (data: FormEvent<HTMLFieldSetElement>) => {
    const newSelectedLineItems = [...selectedLineItems];
    const { value, checked } = data.target as HTMLInputElement;
    if (checked) {
      if (value === 'select-all') {
        for (let i = 0; i < lineItems.length; i += 1) {
          if (!newSelectedLineItems.includes(lineItems[i].lineItemId)) {
            newSelectedLineItems.push(lineItems[i].lineItemId);
          }
        }
      } else {
        newSelectedLineItems.push(value);
      }
    }
    if (!checked && value === 'select-all') {
      newSelectedLineItems.length = 0;
    } else if (!checked && newSelectedLineItems.includes(value)) {
      const index = newSelectedLineItems.indexOf(value);
      newSelectedLineItems.splice(index, 1);
    }
    setSelectedLineItems(newSelectedLineItems);
  };

  return (
    <Panel className="pd-my-4">
      <Panel.Header
        title={(
          <FormattedMessage
            id="quotes.details.lineItemList.title"
            defaultMessage="Articles"
          />
        )}
      />
      <>
        {lineItems?.length && (
          <CheckboxGroup id="quote-line-items" name="quoteLineItems" onClick={handleValueChange}>
            <CheckboxPanel
              name="select-all-line-items"
              id="select-all-line-items"
              key="select-all"
              value="select-all"
              checked={lineItems.length === selectedLineItems.length}
            >
              <CheckboxPanel.Label>
                <FormattedMessage id="lineItems.list.selectAll" defaultMessage="Select All" />
              </CheckboxPanel.Label>
            </CheckboxPanel>
            {lineItems.map((lineItem) => {
              const productDetails = getProductDetails(lineItem);
              return (
                <CheckboxPanel
                  name={lineItem.lineItemId}
                  id={lineItem.lineItemId}
                  key={lineItem.lineItemId}
                  value={lineItem.lineItemId}
                  checked={selectedLineItems.includes(lineItem.lineItemId)}
                >
                  <Grid className="pd-grid-cols-1 pd-gap-4">
                    <CheckboxPanel.Label className="pd-flex pd-justify-between pd-font-semibold">
                      <Heading as="h3">
                        {`${productDetails.productName}, ${productDetails.quantity} st`}
                      </Heading>
                      <span className="pd-text-right">
                        <Money
                          value={productDetails.price.centAmount}
                        />
                      </span>
                    </CheckboxPanel.Label>
                    <QuoteLineItem
                      lineItem={lineItem}
                    />
                  </Grid>

                </CheckboxPanel>
              );
            })}
          </CheckboxGroup>
        )}
      </>
    </Panel>
  );
};

export default QuoteLineItemList;
